import { Controller } from "@hotwired/stimulus"

// GB-14, Verlängerungsmodell C: blendet die Parameter der prozentualen Preisbildung ein
// und den Einzelpreis als Eingabe aus.
//
// Der Einzelpreis wird unter Modell C gerechnet und geschrieben
// (Scaffolding::ExtensionPricingCalculator), nicht eingegeben — ein bedienbares Feld
// behauptete dort eine Eingabe, die der nächste restructure! stillschweigend überschreibt.
// readOnly statt disabled, damit der aktuelle Satz beim Speichern erhalten bleibt und
// sichtbar stehen bleibt, statt aus dem Formular zu verschwinden.
export default class extends Controller {
  static targets = ["modeSelect", "parameters", "unitPriceInput"]
  static values = { percentageMode: String }

  connect() {
    this.modeChanged()
  }

  modeChanged() {
    const percentage =
      this.hasModeSelectTarget && this.modeSelectTarget.value === this.percentageModeValue

    // Die Tailwind-Klasse und nicht das hidden-Attribut: ein display-Utility am selben
    // Element gewänne gegen [hidden] und der Block bliebe sichtbar.
    if (this.hasParametersTarget) this.parametersTarget.classList.toggle("hidden", !percentage)

    if (this.hasUnitPriceInputTarget) {
      this.unitPriceInputTarget.readOnly = percentage
      this.unitPriceInputTarget.classList.toggle("bg-gray-100", percentage)
      this.unitPriceInputTarget.classList.toggle("text-gray-500", percentage)
    }
  }
}
